import { useEffect, useState } from "react";
import { ReactComponent as Close } from "../../assets/x.svg";
import "./AlertModal.scss";
import Button from "../Button/Button";

export default function AlertModal({
  variant = "info",
  message,
  onClose,
  title,
}) {
  // bloquear scroll da página quando modal abre
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div id="alert-modal-backdrop">
      <div className="alert-modal">
        <div className="alert-modal-header">
          <h4>{title}</h4>
        </div>
        <div className="alert-modal-body">
          <div className={`alert-message ${variant}`}>
            <p>{message}</p>
          </div>
        </div>
        <div className="alert-modal-footer">
          <Button variant="secondary" type="button" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
}
